import { Basket as BasketV2 } from "src/resources/api/basket/types.api";
import { ICarbonOffsetImpact, IImpactData, IMoneyImpact } from "./impact";

export interface ISustainableDevelopmentGoal {
    goalNum: string;
    imageUrl: string;
    description: string;
    title: string;
}

export interface FilterOptions {
    regions: string,
    methodCategory: string,
    registry: string,
    searchTerm: string,
    statuses: string[];
}

// TODO: @marina, re/move this type to proper directory (/resources)  
export type Project = {
    carbonOffsetImpact: ICarbonOffsetImpact;
    code: string;
    externalUrl?: string;
    id: string;
    images?: string[];
    imgUrl?: string | null;
    latitude: number;
    locationDescription: string;
    inventoryId: string;
    inventoryOurReference: string;
    longDescription?: string;
    longitude: number;
    name: string;
    portion: number;
    shortDescription: string;
    thumbnailImageUrl: string;
    type: 'MONEY' | 'CARBON' | string;
    projectHighlights?: {
        description: string;
        displayOrder: number;
    }[];
    supplier?: {
        code: string;
        description: string;
        logoUrl: string;
    };
    sustainableDevelopmentGoals?: ISustainableDevelopmentGoal[];
    url?: string;
    registry?: {
        name: string;
        imageUrl?: string;
    },
    impact?: IImpactData;
    method?: string;
    mitigationType?: string;
    media?: {
        displayOrder: number;
        type: string;
        url: string;
    }[];
    estimatedUnitPrice?: {
        price: IMoneyImpact;
        unit: string;
    };
    status?: 'INACTIVE' | 'PRIVATE' | 'PUBLISHED' | 'ACTIVE';
    productType: string;
    numberOfContributions: {
        value: number;
    },
    vintage?: string;
    netAmount?: IMoneyImpact;
    maximumAvailableForPurchase: CarbonOffset;
    regions?: string[];
    methodCategory?: string;
    externalId?: string;
    selectedAmount?: { unit: string, value: number };
}

export type CarbonOffset = {
    unit: string,
    value: number
}

export interface ProjectFilterOptions {
    regions: string;
    methodCategory: string;
    registry: string;
    searchTerm: string;
    goalNums: {
        label: string;
        value: string
    }[];
}

export enum CART_STEPS {
    CREDITS = 0,
    PAYMENT = 1,
    CONFIRMATION = 2,
}

export type Product = ((BasketV2 | Project) & {
    selectedAmount?: {
        value: number;
        unit: string;
    }
});

export const checkIsProject = (obj: Product): obj is Project => {
    if (!obj) return false;
    return !!Object.hasOwnProperty.call(obj, 'method')
        || !!Object.hasOwnProperty.call(obj, 'registry')
}
